export default __webpack_public_path__ + "static/media/kedi-kosan.8735a9fd.png";